var PlaySpinTxStatus = /* @__PURE__ */ ((PlaySpinTxStatus2) => {
  PlaySpinTxStatus2["InProgress"] = "in-progress";
  PlaySpinTxStatus2["Pending"] = "pending";
  PlaySpinTxStatus2["Issued"] = "issued";
  return PlaySpinTxStatus2;
})(PlaySpinTxStatus || {});
export {
  PlaySpinTxStatus
};
